module.exports = __webpack_public_path__ + "static/img/sing.df0784c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/images/sing.png
// module id = aaAN
// module chunks = 1